/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.timesheets.review-timesheets'},
});

const ReviewTimesheetsItem = () => (
  <RouteLinkItem
    route="midas/settings/timesheets/timesheets-review"
    title={messages.title}
  />
);

export default ReviewTimesheetsItem;
